import AbsModule from "../common/AbsModule";
import Login from '../header/Login';
import PurpleUrl from "./PurpleUrl";

class PurpleUserInfo extends AbsModule {
    static PARENT_TYPE_BOTTOM_NAV = 'parent_type_bottom_nav';
    static PARENT_TYPE_PANEL = 'parent_type_panel';

    constructor(config) {
        super(config);

        this.isLogin = this.moduleData?.userData?.isLogin;
        this.login = new Login(config);
    }

    startSetting({ parentType = PurpleUserInfo.PARENT_TYPE_BOTTOM_NAV, parent }) {
        if(!parent || !parent?.length === 0) {
            return;
        }

        if(this.isLogin) {
            const btnBottomNav = parent?.querySelector('.ncc-bottom-nav__button');
            const loginInfoA = parent?.querySelector('.ncc-login--info a');
            const characterPanel = document.querySelector('.ncc-character-panel');
            let charChangeFN = this.moduleData.charChangeFN;

            // loginInfoA => 퍼플 스킴 및 프로필 url 붙인 이동 URL 생성
            this.setProfileUrl(loginInfoA);

            // btnBottomNav => 대표캐릭터 변경 드로어 오픈
            btnBottomNav?.addEventListener('click', e => {
                e.preventDefault();
                this.dim.openClose(true, 'right');

                if (typeof charChangeFN === 'string' && typeof window[charChangeFN] === 'function') {
                    charChangeFN = window[charChangeFN];
                }

                if (typeof charChangeFN === 'function') {
                    charChangeFN();
                    characterPanel?.classList?.add('is-active');
                    this.settingMMOGA360(); // (임시) MMO IP ga360 주입
                }
                
                return false;
            });
        } else {
            const { purpleCheck, config, env } = this.com || {};
            const { isPurpleLauncher } = purpleCheck;
            const { goPurpleErrorPageInCnb } = config || {};
            const btnLogin = parent?.querySelector('.ncc-login--before .ncc-login__link');
            let loginFN = this.moduleData.loginFN;

            btnLogin?.addEventListener('click', e => {
                e.preventDefault();

                if(isPurpleLauncher && goPurpleErrorPageInCnb) {
                    PurpleUrl.goErrorPage(env); // 퍼플 런처 에러페이지로 이동
                    return;
                }

                if (typeof loginFN === 'string' && typeof window[loginFN] === 'function') {
                    loginFN = window[loginFN];
                }

                if (typeof loginFN === 'function') {
                    loginFN();
                }
                
                return false;
            });
        }

        this.settingGA360(parent); // GA360 setting
    }

    makeMarkup() {
        if(this.isLogin) {
            const userData = this.login.setUserData();
            const { caseNum } = userData || {};
            const { useCharChangeMenu } = this.moduleData || {};
            const hasNoCharacter = caseNum === 3;

            return `${this.login.loginInfoMarkup(userData)}
                    ${useCharChangeMenu && !hasNoCharacter ? `<button type="button" class="ncc-bottom-nav__button">
                        <span class="hidden">${this.com.l10nData.Mycharacter.SelectMainCharacter}</span>
                    </button>` : ''}`;
        } else {
            return this.login.markUp;
        }
    }

    setProfileUrl(target) {
        if(!target || target?.tagName !== 'A') return;

        try {
            const { purpleCheck } = this.com || {};
            const { isPurpleLauncher } = purpleCheck;
            const userData = this.login.setUserData();
            const { userInfo } = userData || {};
            const url = new URL(userInfo?.url || '', window.location.origin)?.toString();

            if(isPurpleLauncher) {
                // 프로필 영역 클릭 시 sso url api 호출 및 외부 브라우저 실행
                target.addEventListener('click', e => {
                    e.preventDefault();

                    PurpleUrl.ssoUrlExternal(url); // 외부 브라우저로 이동

                    return false;
                });
            } else {
                // const urlAddParam = PurpleUrl.setUrlAddPurpleParam(url);
                // target.href = PurpleUrl.setPurpleAppScheme('external', urlAddParam);
                target.href = url; // 이번 스펙에선 인앱브라우저 내부에서만 이동하는 걸로
            }
        } catch(e) {
            console.error(e);
        }
    }

    getGA360Data() {
        const { purpleCheck } = this.com || {};
        const { isPurpleLauncher, isPurpleApp } = purpleCheck;
        const deviceName = isPurpleLauncher ? 'PC 론처' : isPurpleApp ? 'Mobile' : '';
        const areaTxt = `퍼플 커뮤니티_${deviceName}_CNB 클릭`;
        const contentsTxt = `클릭 컨텐츠 : ${deviceName}_CNB_`;

        return { areaTxt, contentsTxt };
    }

    settingGA360(parent) {
        const loginInfoA = parent?.querySelector('.ncc-login--info > a');
        const bottomNavBtn = parent?.querySelector('.ncc-bottom-nav__button');
        const btnCharacterClose = document.querySelector('.ncc-character-panel-close');
        const ga360Map = new Map();
        const { areaTxt, contentsTxt } = this.getGA360Data();

        ga360Map.set(loginInfoA, {area: areaTxt, contents: `${contentsTxt}유저 네임`});
        ga360Map.set(bottomNavBtn, {area: areaTxt, contents: `${contentsTxt}대표 캐릭터 변경 아이콘`});
        ga360Map.set(btnCharacterClose, {area: areaTxt, contents: `${contentsTxt}우측 슬라이드 닫기 아이콘`});
        
        if(ga360Map?.size > 0) {
            for(const [key, value] of ga360Map.entries()) {
                const { area, contents } = value || {};
                area && key?.setAttribute('data-area', area);
                contents && key?.setAttribute('data-contents', contents);
            }
        }
    }

    settingMMOGA360Observer() {
        const target = document?.querySelector('.ncc-character-list');
        
        this.observer = new MutationObserver(() => {
            const { areaTxt, contentsTxt } = this.getGA360Data();
            const area = areaTxt;
            const contents = `${contentsTxt}우측 슬라이드 대표 캐릭터 선택`;

            const targetElements = target.querySelectorAll('li li');
            targetElements?.forEach(v => {
                area && v?.setAttribute('data-area', area);
                contents && v?.setAttribute('data-contents', contents);
            });
        });

        this.observer.observe(target, {subtree: true, childList: true});
    }

    settingMMOGA360() {
        const serviceName = userData?.site || document.querySelector('html')?.getAttribute('data-service');

        if(!['aion', 'bns', 'lineage', 'lineage2'].includes(serviceName)) {
            return;
        }

        if(!this.observer) {
            this.settingMMOGA360Observer();
        }
    }
}

export default PurpleUserInfo;